// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Particle_Screen_Ds = require("./Particle_Screen_Ds.bs.js");

function toMainColor(color) {
  if (color === "Divider" || color === "Text" || color === "Grey" || color === "Arte" || color === "Background" || color === "TransparentBackground" || color === "CorporateBorder" || color === "Transparent" || color === "Error" || color === "Success" || color === "DividerStatic" || color === "LightGrey" || color === "White" || color === "Concert" || color === "DarkGrey" || color === "Primary" || color === "Black") {
    return color;
  } else {
    return "White";
  }
}

function make(x) {
  var exit = 0;
  if (typeof x === "number") {
    switch (x) {
      case /* Accessibility */0 :
          return {
                  color: "White",
                  width: 100,
                  weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Medium"),
                  position: /* Outside */3
                };
      case /* CorporateAccessibility */3 :
          return {
                  color: "Background",
                  width: 100,
                  weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Medium"),
                  position: /* Outside */3
                };
      case /* CorporateBurgerMenu */4 :
          return {
                  color: "Background",
                  width: 100,
                  weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Medium"),
                  position: /* Border */1
                };
      case /* CorporateBurgerMenuLine */5 :
          return {
                  color: "Background",
                  width: 100,
                  weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Medium"),
                  position: /* BorderBottom */{
                    _0: undefined
                  }
                };
      case /* CorporateMenuDivider */6 :
          return {
                  color: "CorporateBorder",
                  width: 100,
                  weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Medium"),
                  position: /* BorderLeft */2
                };
      case /* CorporateMenuItemChild */7 :
          return {
                  color: "CorporateBorder",
                  width: 100,
                  weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                  position: /* BorderBottom */{
                    _0: undefined
                  }
                };
      case /* DividerDefault */8 :
          return {
                  color: "DarkGrey",
                  width: 100,
                  weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                  position: /* BorderBottom */{
                    _0: undefined
                  }
                };
      case /* DividerFooter */9 :
      case /* DividerMona */11 :
          exit = 3;
          break;
      case /* Error */13 :
          return {
                  color: "Error",
                  width: 100,
                  weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                  position: /* Border */1
                };
      case /* EventInfoLink */14 :
          return {
                  color: "Arte",
                  width: 100,
                  weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                  position: /* BorderBottom */{
                    _0: "Arte"
                  }
                };
      case /* AndroidRealeaseCtaDownload */1 :
      case /* EventZoneTrailer */15 :
          exit = 1;
          break;
      case /* Header */17 :
          return {
                  color: "Transparent",
                  width: 100,
                  weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Medium"),
                  position: /* Border */1
                };
      case /* HeaderSocialLink */18 :
          return {
                  color: "Grey",
                  width: 100,
                  weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                  position: /* BorderLeft */2
                };
      case /* None */19 :
          return {
                  color: "Transparent",
                  width: 0,
                  weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "None"),
                  position: /* Border */1
                };
      case /* PresseBurgerMenu */20 :
          return {
                  color: "White",
                  width: 100,
                  weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Medium"),
                  position: /* Border */1
                };
      case /* BurgerMenuLine */2 :
      case /* PresseBurgerMenuLine */21 :
          exit = 2;
          break;
      case /* DividerPlayer */12 :
      case /* PresseMenuItemChild */22 :
          exit = 4;
          break;
      case /* PresseTextField */23 :
          return {
                  color: toMainColor("Text"),
                  width: 100,
                  weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                  position: /* Border */1
                };
      case /* SettingsDropdown */25 :
          return {
                  color: "Primary",
                  width: 100,
                  weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                  position: /* Border */1
                };
      case /* Sharebar */26 :
          exit = 5;
          break;
      case /* SliderButton */27 :
          return {
                  color: "Black",
                  width: 100,
                  weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                  position: /* Inset */4
                };
      case /* TeaserCta */28 :
          exit = 7;
          break;
      case /* TeaserInfoAccessibility */29 :
          return {
                  color: "Arte",
                  width: 100,
                  weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Medium"),
                  position: /* Outside */3
                };
      case /* UserPanel */30 :
          return {
                  color: "LightGrey",
                  width: 100,
                  weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                  position: /* BorderBottom */{
                    _0: undefined
                  }
                };
      default:
        return {
                color: "Grey",
                width: 100,
                weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                position: /* BorderBottom */{
                  _0: undefined
                }
              };
    }
  } else {
    switch (x.TAG | 0) {
      case /* Checkbox */0 :
          if (!x._0) {
            return {
                    color: toMainColor("Text"),
                    width: 100,
                    weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Medium"),
                    position: /* Border */1
                  };
          }
          exit = 6;
          break;
      case /* Corporate */1 :
          if (x._0) {
            return {
                    color: "White",
                    width: 100,
                    weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                    position: /* Border */1
                  };
          } else {
            return {
                    color: "Black",
                    width: 100,
                    weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                    position: /* Border */1
                  };
          }
      case /* Cta */2 :
          if (x._0) {
            if (x._1 === "Medium") {
              return {
                      color: "Transparent",
                      width: 100,
                      weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Medium"),
                      position: /* Border */1
                    };
            } else {
              return {
                      color: toMainColor("Text"),
                      width: 100,
                      weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                      position: /* Border */1
                    };
            }
          } else {
            return {
                    color: toMainColor("Text"),
                    width: 100,
                    weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, x._1),
                    position: /* Border */1
                  };
          }
      case /* Progression */3 :
          return {
                  color: "Arte",
                  width: x._0,
                  weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "SemiBold"),
                  position: /* BorderBottom */{
                    _0: "DividerStatic"
                  }
                };
      case /* SettingsMenu */4 :
          return {
                  color: x._0,
                  width: 100,
                  weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                  position: /* BorderBottom */{
                    _0: undefined
                  }
                };
      case /* TeaserDirect */5 :
          return {
                  color: x._0,
                  width: 100,
                  weight: Particle_Screen_Ds.make(undefined, "SemiBold", undefined, undefined, undefined, "Medium"),
                  position: /* Around */0
                };
      case /* TeaserGenre */6 :
          var state = x._1;
          return {
                  color: state ? "Transparent" : x._0,
                  width: 100,
                  weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, state ? "None" : "SemiBold"),
                  position: /* Around */0
                };
      case /* Textfield */7 :
          switch (x._0) {
            case /* Active */0 :
                return {
                        color: toMainColor("Text"),
                        width: 100,
                        weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                        position: /* Border */1
                      };
            case /* Inactive */1 :
                exit = 6;
                break;
            case /* NewsletterZone */2 :
                exit = 7;
                break;
            case /* SearchPage */3 :
                return {
                        color: "LightGrey",
                        width: 100,
                        weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                        position: /* Border */1
                      };
            case /* TvCodeCell */4 :
                exit = 5;
                break;
            
          }
          break;
      case /* Underline */8 :
          var color = x._0;
          if (color) {
            return {
                    color: color._0,
                    width: 100,
                    weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                    position: /* BorderBottom */{
                      _0: undefined
                    }
                  };
          } else {
            return {
                    color: "Transparent",
                    width: 100,
                    weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                    position: /* BorderBottom */{
                      _0: undefined
                    }
                  };
          }
      
    }
  }
  switch (exit) {
    case 2 :
        return {
                color: "White",
                width: 100,
                weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Medium"),
                position: /* BorderBottom */{
                  _0: undefined
                }
              };
    case 3 :
        return {
                color: "DividerStatic",
                width: 100,
                weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                position: /* BorderBottom */{
                  _0: undefined
                }
              };
    case 4 :
        return {
                color: "White",
                width: 100,
                weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                position: /* BorderBottom */{
                  _0: undefined
                }
              };
    case 5 :
        return {
                color: toMainColor("LightGrey"),
                width: 100,
                weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                position: /* Border */1
              };
    case 6 :
        return {
                color: "LightGrey",
                width: 100,
                weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                position: /* Border */1
              };
    case 1 :
    case 7 :
        return {
                color: "White",
                width: 100,
                weight: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Regular"),
                position: /* Border */1
              };
    
  }
}

function view(param) {
  return {
          color: param.color,
          width: param.width,
          weight: param.weight,
          position: param.position
        };
}

exports.make = make;
exports.view = view;
/* No side effect */
